var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H12C10.8954 10 10 10.8954 10 12V14M5 5.66667H11M5 8L8.66667 7.99993M5 10.3333H6.66667M14 5.33333V9.95262C14 10.8367 13.6488 11.6845 13.0237 12.3096L12.3096 13.0237C11.6845 13.6488 10.8367 14 9.95262 14H5.33333C3.49238 14 2 12.5076 2 10.6667V5.33333C2 3.49238 3.49238 2 5.33333 2H10.6667C12.5076 2 14 3.49238 14 5.33333Z",
    stroke: "#23242A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmNotes);
export default __webpack_public_path__ + "static/media/sm-notes.1aa7c6ecd2a8580823c82c35ba38073b.svg";
export { ForwardRef as ReactComponent };